import { constants } from "redux/constants/redux-constants";

const initialState = {
  status: 'idle', // idle | uploading | polling | completed | error
  agentName: null, // source_pdf — set on UPLOAD_SUCCESS, persists through polling
  message: '',
  step: 0,
  totalSteps: 3,
  pollURL: null,
  result: null,
  error: null,
};

const PIAHybridV2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.PIA_HYBRID_V2.UPLOAD_START:
      return {
        ...initialState,
        status: 'uploading',
      };

    case constants.PIA_HYBRID_V2.UPLOAD_SUCCESS:
      return {
        ...state,
        status: 'polling',
        agentName: action.payload?.source_pdf || state.agentName,
        pollURL: action.payload?.poll || null,
      };

    case constants.PIA_HYBRID_V2.UPLOAD_FAILURE:
      return {
        ...state,
        status: 'error',
        error: action.error || action.payload,
      };

    case constants.PIA_HYBRID_V2.POLL_STATUS:
      return {
        ...state,
        status: 'polling',
        message: action.payload?.message || state.message,
        step: action.payload?.step || state.step,
        totalSteps: action.payload?.totalSteps || state.totalSteps,
      };

    case constants.PIA_HYBRID_V2.POLL_COMPLETE:
      return {
        ...state,
        status: 'completed',
        agentName: action.payload?.source_pdf || action.payload?.tutor_label || state.agentName,
        result: action.payload,
        message: action.payload?.message || 'Completed',
      };

    case constants.PIA_HYBRID_V2.POLL_ERROR:
      return {
        ...state,
        status: 'error',
        error: action.error || action.payload,
      };

    case constants.PIA_HYBRID_V2.STATUS_UPDATE:
      return {
        ...state,
        status: action.payload.status,
        message: action.payload.message,
        step: action.payload.step || state.step,
        totalSteps: action.payload.totalSteps || state.totalSteps,
      };

    case constants.PIA_HYBRID_V2.RESET:
      return initialState;

    default:
      return state;
  }
};

export default PIAHybridV2Reducer;
